import React from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

// Render de un documento legal (markdown) con estilos propios (no depende de `prose`).
// Recibe un objeto { titulo, version, contenido } de src/lib/services/legal.js.
const components = {
  h1: ({ children }) => <h1 className="text-xl font-bold text-foreground mt-2 mb-3">{children}</h1>,
  h2: ({ children }) => (
    <h2 className="text-base font-semibold text-foreground mt-5 mb-2">{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 className="text-sm font-semibold text-foreground mt-4 mb-1.5">{children}</h3>
  ),
  p: ({ children }) => <p className="text-sm text-muted-foreground leading-relaxed mb-3">{children}</p>,
  ul: ({ children }) => (
    <ul className="list-disc pl-5 text-sm text-muted-foreground space-y-1 mb-3">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal pl-5 text-sm text-muted-foreground space-y-1 mb-3">{children}</ol>
  ),
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-foreground">{children}</strong>,
  a: ({ children, href }) => (
    <a href={href} className="text-primary underline" target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  blockquote: ({ children }) => (
    <blockquote className="border-l-4 border-border bg-muted/40 rounded-r px-3 py-2 text-sm text-muted-foreground italic mb-3">
      {children}
    </blockquote>
  ),
  hr: () => <hr className="my-4 border-border" />,
  table: ({ children }) => (
    <div className="overflow-x-auto mb-3">
      <table className="w-full text-sm border-collapse">{children}</table>
    </div>
  ),
  th: ({ children }) => (
    <th className="border border-border bg-muted px-2 py-1 text-left font-semibold text-foreground">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="border border-border px-2 py-1 text-muted-foreground align-top">{children}</td>
  ),
}

const LegalDocViewer = ({ doc }) => {
  if (!doc) return null
  return (
    <div>
      {doc.version && (
        <p className="text-xs text-muted-foreground mb-3">Versión: {doc.version}</p>
      )}
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {doc.contenido}
      </Markdown>
    </div>
  )
}

export default LegalDocViewer
